<button
  class="btn btn-dropdown-trigger"
  atxDropdown
  [atxDropdownMenu]="menu"
  [atxTrigger]="trigger"
  [atxDisabled]="disabled"
  [atxClickHide]="clickHide"
  [atxPlacement]="placement"
>
  <ng-container *ngIf="icon && iconConfig.placement === 'prefix'">
    <fa-icon
      [icon]="icon"
      [size]="iconConfig.size"
      [class.mr-1]="!!text"
    ></fa-icon>
  </ng-container>
  <ng-container *ngIf="text">{{ text }}</ng-container>
  <ng-container *ngIf="icon && iconConfig.placement === 'suffix'">
    <fa-icon
      [icon]="icon"
      [size]="iconConfig.size"
      [class.ml-2]="!!text"
    ></fa-icon>
  </ng-container>
</button>
<atx-dropdown-menu #menu="atxDropdownMenu">
  <ng-container *ngFor="let item of dropdownItems" [ngSwitch]="item.type">
    <ng-container *epcDynamicComponentIf="item.if">
      <ng-container *ngSwitchCase="'item'">
        <atx-dropdown-item
          [icon]="item.config.icon"
          [active]="item.config.active | dynamicOperationIf"
          (click)="onClick(item)"
        >
          {{ item.config.text | dynamicLocalePipe }}
        </atx-dropdown-item>
      </ng-container>

      <ng-container *ngSwitchCase="'link'">
        <atx-dropdown-item>
          <a
            class="stretched-link item-link"
            [target]="item.config.target"
            [href]="item.config.href"
            rel="noopener norefferrer"
          >
            {{ item.config.text | dynamicLocalePipe }}
          </a>
        </atx-dropdown-item>
      </ng-container>

      <ng-container *ngSwitchCase="'label'">
        <atx-dropdown-header>
          {{ item.config.text | dynamicLocalePipe }}
        </atx-dropdown-header>
      </ng-container>

      <ng-container *ngSwitchCase="'divider'">
        <atx-dropdown-divider></atx-dropdown-divider>
      </ng-container>
    </ng-container>
  </ng-container>
</atx-dropdown-menu>
